import React from 'react'
import './testimonials.css'
import CAROUSEL from '../../components/Carousel/Carousel'



const Testimonials = () => {
  return (
    <section id='testimonials'>

      <div className='testimonials'>
          <div className='testimonials__header'>Testimonials</div>
          <div className='testimonials__description'>See what others have to say</div>
          <div className='testimonials__content'>
            <CAROUSEL/>
          </div>
      </div>
    </section>
  )
}

export default Testimonials